import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Box,
  Button,
  Text,
} from '@razorpay/blade/components';
import { getContractorText } from 'utils/getContractorText';
import useReduxSelector from 'utils/useReduxSelector';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';

interface SuccessModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  employeeName: string;
  userId: number | undefined;
}

export const SuccessModal = ({
  isOpen,
  onDismiss,
  employeeName,
  userId,
}: SuccessModalProps) => {
  const isRxCurrentAccountMerchant = !!useReduxSelector(loggedInUserSelectors.currentOrganization)
    ?.isRxCurrentAccountMerchant;
  const featureFlags = useReduxSelector(loggedInUserSelectors.features);

  const { contractorTitleCase } = getContractorText({
    isRxCurrentAccountMerchant,
    featureFlags,
  });

  if (!userId) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onDismiss}
      size="small"
      accessibilityLabel="Contractor Added Successfully">
      <ModalHeader title={`${contractorTitleCase} Added Successfully!`} />

      <ModalBody>
        <Text size="medium" color="surface.text.gray.normal">
          {employeeName} has been added. However, they need to complete their profile by adding
          details like bank information and phone number. You can update their profile manually as
          well.
        </Text>
      </ModalBody>

      <ModalFooter>
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" width="100%">
          <Button
            variant="primary"
            onClick={() => (window.location.href = `/employeeDetail?userId=${userId}`)}>
            Continue
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
